export enum CookiesName {
  zmyleCookie = 'zmyle-cookie',
}
